import React, { useEffect } from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import TransfersApprovalSearchAndFilterBar from './TransfersApprovalSearchAndFilterBar';
import TransfersApprovalTable from './TransfersApprovalTable';
import TransfersApprovalTablePaginator from './TransfersApprovalPagination';
import ConfirmupdateTransferStatusModal from './ConfirmUpdateTransfersStatusModal';

const TransferApproval = () => {
    const dispatch = useAppDispatch();

    const transfersListingIndex = useAppSelector(state => state.approval.pendingTransferListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingTransferListingAttempt());
    }, [transfersListingIndex]);

    return (
        <TabPageContainer>
            <TransfersApprovalSearchAndFilterBar />

            <TransfersApprovalTable />

            <TransfersApprovalTablePaginator />

            <ConfirmupdateTransferStatusModal />
        </TabPageContainer>
    );
};

export default TransferApproval;
